import { c as _c } from "react/compiler-runtime";
import { RemoveTeamDialog } from "@components/table/teams/remove-team-dialog";
import { DeleteIcon, MenuItem } from "@flat-ui";
import { useState } from "react";
/**
 * Menu item that opens a remove-team confirmation dialog.
 */
export function RemoveTeamMenuButton(t0) {
  const $ = _c(9);
  const {
    team,
    onMenuClose
  } = t0;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t1;
  if ($[0] !== onMenuClose) {
    t1 = function closeDialog() {
      setIsDialogOpen(false);
      onMenuClose();
    };
    $[0] = onMenuClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closeDialog = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MenuItem label="Remove team" Icon={DeleteIcon} onClick={() => setIsDialogOpen(true)} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== closeDialog || $[4] !== isDialogOpen || $[5] !== team) {
    t3 = isDialogOpen && <RemoveTeamDialog team={team} onClose={closeDialog} />;
    $[3] = closeDialog;
    $[4] = isDialogOpen;
    $[5] = team;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}